var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MimeTypeService } from './MimeTypeService';
import { convertBlobToBase64, dataURLtoFile } from './FileUtils';
const piexif = require('piexifjs');
export const isJpegImage = (fileName) => {
    const mimeType = MimeTypeService.lookup(fileName);
    switch (mimeType) {
        case 'image/jpeg':
        case 'image/jpg':
            return true;
        default:
            return false;
    }
};
const getJpegImageExifObject = (jpegDataUrl) => piexif.load(jpegDataUrl);
const convertJpegImageExifToBytes = (exifObj) => piexif.dump(exifObj);
const insertExifToJpegImage = (exifBytes, jpegDataUrl) => piexif.insert(exifBytes, jpegDataUrl);
export const getJpegImageExifOrientation = (exifObj) => {
    let orientation = undefined;
    if (exifObj && exifObj['0th'] && exifObj['0th'][piexif.ImageIFD.Orientation]) {
        orientation = exifObj['0th'][piexif.ImageIFD.Orientation];
    }
    return orientation;
};
export const hasExifOrientation = (exifObj) => {
    return !!(exifObj && exifObj['0th'] && exifObj['0th'][piexif.ImageIFD.Orientation]);
};
const hasPiexifImageDescriptionKey = () => !!(piexif && piexif.ImageIFD && piexif.ImageIFD.ImageDescription);
export function processJpegImageExif(originFile, fileName, resizedFile, fileDescription = '') {
    return __awaiter(this, void 0, void 0, function* () {
        const originFileDataUrl = yield convertBlobToBase64(originFile);
        let exifObj = getJpegImageExifObject(originFileDataUrl);
        // if original JPEG image does not have exif orientation, fail fast by throwing reject promise
        if (!(hasExifOrientation(exifObj) || fileDescription)) {
            return new Promise((resolve, reject) => {
                reject('Original JPEG image has no EXIF Orientation');
            });
        }
        if (originFile !== resizedFile) {
            // Set Exif image orientation to 1 (Horizontal - Normal) when image is compressed
            exifObj['0th'][piexif.ImageIFD.Orientation] = 1;
        }
        // Set the file description of the attachment into the ImageDescription field of the Exif object
        if (fileDescription && exifObj && exifObj['0th'] && hasPiexifImageDescriptionKey()) {
            exifObj['0th'][piexif.ImageIFD.ImageDescription] = fileDescription;
        }
        const exifBytes = convertJpegImageExifToBytes(exifObj);
        const resizedFileDataUrl = yield convertBlobToBase64(resizedFile);
        const fileDataUrlWithExif = insertExifToJpegImage(exifBytes, resizedFileDataUrl);
        return new Promise((resolve, reject) => {
            const resultFile = dataURLtoFile(fileDataUrlWithExif, fileName);
            resultFile ? resolve(resultFile) : reject('Error occurs when convert JPEG image with EXIF to File');
        });
    });
}
//# sourceMappingURL=JpegImageUtils.js.map